export default {
  API_ENDPOINT: "https://sheltered-waters-10877.herokuapp.com/api",

   //API_ENDPOINT: "http://localhost:8000/api",

  REACT_APP_API_KEY: process.env.REACT_APP_API_KEY
};
